import React from "react";

import { ModuleOperation } from "src/api/modulesApi";
import { ObjectDetailPane } from "src/dataTable/ObjectDetailPane";
import { Modal } from "src/design-system/Modal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  afterLeave: () => void;
  operation: ModuleOperation | undefined;
};

export const PatchViewerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  afterLeave,
  operation,
}) => {
  return (
    <Modal afterLeave={afterLeave} open={isOpen} size="md" onClose={onClose}>
      <Modal.Header
        description={
          operation
            ? `Operation ${operation.id} · ${operation.status}`
            : undefined
        }
      >
        Operation Patch
      </Modal.Header>
      <Modal.Content>
        {operation && (
          <ObjectDetailPane
            defaultInspectDepth={5}
            jsonObject={operation.patch}
            speakPython={false}
          />
        )}
      </Modal.Content>
      <Modal.Footer primaryButton={false} secondaryButton="Close" />
    </Modal>
  );
};
